.table thead {
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: var(--mantine-primary-color-9);
  color: var(--mantine-primary-color-contrast);
}

.table th,
.table td {
  padding: 4px 14px;
}

.table tbody tr th.right,
.table tbody tr td.right {
  text-align: right;
}

.table tbody tr .controls {
  position: relative;
  top: 4px;
  display: flex;
  align-items: center;
  gap: 6px;
}
